// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserBioList, updateUserBioList } from "../../slices/userBioSlice";
// import Pagination from "../../components/Pagination";
// import EditableTable from "../../components/EditableTable";
// import Modal from "../../components/Modal";
// import ChangeLog from "../../components/ChangeLog";

// const Points = () => {
//   const dispatch = useDispatch();
//   const { userBioList, status, error } = useSelector((state) => state.userBioList);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
//   const [editedData, setEditedData] = useState({}); // Store temporary data for edited row

//   const itemsPerPage = 4;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = Array.isArray(userBioList.result)
//     ? userBioList.result?.slice(indexOfFirstItem, indexOfLastItem)
//     : [];
//   const totalPages = Array.isArray(userBioList.result)
//     ? Math.ceil(userBioList.result?.length / itemsPerPage)
//     : 0;
//   const editableFields = ["title"];

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [currentLog, setCurrentLog] = useState([]);

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   useEffect(() => {
//     dispatch(fetchUserBioList());
//   }, [dispatch]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleEdit = (rowId) => {
//     setEditRowId(rowId);
//     const rowData = userBioList.result?.find((user) => user.id === rowId);
//     setEditedData(rowData); // Pre-fill the fields with current row data
//   };

//   const handleSave = async () => {
//     // Extract only id, point, and detail for the API call
//     const { id, title } = editedData;
//     const updatedData = { id, title};
//     await dispatch(updateUserBioList(updatedData));
//     dispatch(fetchUserBioList());
//     setEditRowId(null); // Exit edit mode after saving
//   };

//   const handleCancel = () => {
//     setEditRowId(null); // Exit edit mode and reset data
//     setEditedData({}); // Reset to original data
//   };

//   const handleLog = (id) => {
//     const logData = userBioList?.Change_Log?.filter((f) => f.id === id)[0]?.oldTrack;
//     setCurrentLog(logData);
//     openModal();
//   };

//   const handleChange = (e, field, val) => {
//     if (field === "active" || field === "status") {
//       setEditedData((prev) => ({
//         ...prev,
//         [field]: !val,
//       }));
//     } else {
//       setEditedData((prev) => ({
//         ...prev,
//         [field]: e.target.value,
//       }));
//     }
//   };

//   const headers =
//     userBioList.result?.length > 0
//       ? Object.keys(userBioList.result[0]).filter((key) => key !== "id")
//       : [];

//   if (status === "loading") {
//     return <div>Loading...</div>;
//   }

//   if (status === "failed") {
//     return <div>Error: {error}</div>;
//   }

//   if (!userBioList || userBioList.length === 0) {
//     return <div>No data available</div>;
//   }

//   return (
//     <div className="pt-14 w-full flex items-center flex-col">
//       <h1 className="text-center m-4 text-xl font-semibold">User Bio</h1>
//       <div className="max-w-[90%]">
//         <EditableTable
//           headers={headers}
//           rows={currentItems}
//           editRowId={editRowId}
//           editedData={editedData}
//           handleEdit={handleEdit}
//           handleSave={handleSave}
//           handleCancel={handleCancel}
//           handleChange={handleChange}
//           handleLog={handleLog}
//           editableFields={editableFields} // Pass editable fields
//         />
//       </div>

//       <div className="flex mt-4 items-center justify-between w-11/12">
//         <Pagination
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//           totalPages={totalPages}
//         />
//       </div>
//       <Modal
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         title="Change Log"
//         content={<ChangeLog data={currentLog} />}
//       />
//     </div>
//   );
// };

// export default Points;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserBioList,
  updateUserBioList,
  setPage,
  setPageSize , clearCache
} from "../../slices/userBioSlice";

import EditableTable from "../../components/EditableTable";
import Modal from "../../components/Modal";
import ChangeLog from "../../components/ChangeLog";
import SimplePagination from "@/components/SimplePagination";
import PageSizeSelector from "@/components/PageSizeSelector";
import Loader from '../../components/Loader';

const Points = () => {
  const dispatch = useDispatch();

  const {
    userBioList,
    currentPage,
    totalPages,
    status,
    pageSize
  } = useSelector((state) => state.userBioList);

  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);

  const editableFields = ["title"];

  // ✅ Fetch data (ONLY API pagination)
  useEffect(() => {
    dispatch(fetchUserBioList({ page: currentPage }));
  }, [dispatch, currentPage, pageSize]);

  // ✅ Page change
  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  // ✅ Page size change
  const handlePageSizeChange = (size) => {
    dispatch(setPageSize(size));
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = userBioList.result?.find((u) => u.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, title } = editedData;
    
    await dispatch(updateUserBioList({ id, title }));

    await dispatch(clearCache()); // resets cache internally
    dispatch(fetchUserBioList({ page: currentPage }));
    setEditRowId(null);
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleLog = (id) => {
    const logData =
      userBioList?.Change_Log?.find((f) => f.id === id)?.oldTrack || [];
    setCurrentLog(logData);
    setIsModalOpen(true);
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: e.target.value
    }));
  };
  
    if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  const headers =
    userBioList.result?.length > 0
      ? Object.keys(userBioList.result[0]).filter((key) => key !== "id")
      : [];

      const hasData = userBioList.result && userBioList.result.length > 0;

  return (
    <div className="pt-14 w-full flex items-center flex-col">
      <h1 className="text-center m-4 text-xl font-semibold">User Bio</h1>

     <div className="max-w-[90%] w-full flex justify-center">
        {hasData ? (
          <EditableTable
            headers={headers}
            rows={userBioList.result || []}
            editRowId={editRowId}
            editedData={editedData}
            handleEdit={handleEdit}
            handleSave={handleSave}
            handleCancel={handleCancel}
            handleChange={handleChange}
            handleLog={handleLog}
            editableFields={editableFields}
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-gray-500">
            <div className="text-5xl mb-3">🔍</div>
            <div className="text-lg font-medium">No Data Available</div>
            <div className="text-sm text-gray-400 mt-1">
              There are no records to display at the moment.
            </div>
          </div>
        )}
      </div>

      {/* ✅ Pagination + Page Size */}
     {hasData && (
      <div className="flex mt-4 items-center justify-between w-11/12">

        <PageSizeSelector
          pageSize={pageSize}
          setPageSize={handlePageSizeChange}
        />

        <SimplePagination
          currentPage={currentPage}
          setCurrentPage={handlePageChange}
          totalPages={totalPages}
        />

      </div>
    )}

      {/* ✅ Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />
    </div>
  );
};

export default Points;